import { StreamMessage } from 'stream-chat-react';

import { PinIcon } from '../../assets';

import { StreamChatType } from '../../types';

export type PinIndicatorProps = {
  message?: StreamMessage<StreamChatType>;
};

export const PinIndicator = ({ message }: PinIndicatorProps) => {
  if (!message) return null;

  const pinnedBy = message.pinned_by;
  const pinnedMessageText = pinnedBy
    ? `Pinned by ${pinnedBy.name || pinnedBy.id}`
    : 'Message pinned';

  return (
    <div className='str-chat__message-team-pin-indicator'>
      <PinIcon />
      {pinnedMessageText}
    </div>
  );
};
